import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { DbAnalyticsProvider } from 'src/app/providers/database/db-analytics';
import { DbEventsProvider } from 'src/app/providers/database/db.events';
import { FormatedEventLanguageService } from 'src/app/providers/formated-event-language/formated-event-language.service';
import { GlobalService } from 'src/app/providers/global/global.service';
import { AppState } from 'src/app/shared/reducers';
import { getChatsAnalytics } from 'src/app/shared/selectors/analytics.selectors';

@Component({
    selector: 'app-chat-analytics',
    templateUrl: './chat-analytics.component.html',
    styleUrls: ['./chat-analytics.component.scss']
})
export class ChatAnalyticsComponent implements OnInit {
    loader: boolean = true;

    event: any;
    eventId: string;
    userLanguage: string;

    totalChats: number = 0;
    totalChatsUsers: number = 0;
    totalMessagesOnChats: number = 0;
    totalDiscussionGroups: number = 0;
    totalDiscussionGroupsUsers: number = 0;
    totalMessagesOnDiscussionGroups: number = 0;

    constructor(
        private route: ActivatedRoute,
        private dbEvent: DbEventsProvider,
        private dbAnalytics: DbAnalyticsProvider,
        private global: GlobalService,
        public formatedLanguage: FormatedEventLanguageService,
        private store: Store<AppState>
    ) { }

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.eventId = params.uid;
            this.getUserLanguage()
            this.getEvent();
        })
    }

    getUserLanguage() {
        this.global.getLanguage((language) => {
            this.userLanguage = this.formatedLanguage.convertLang(language);
        })
    }

    getEvent() {
        this.dbEvent.getEvent(this.eventId, (event) => {
            this.event = event;
            this.formatedLanguage.convertLangFormat(event.language);
            this.dbAnalytics.getChatsAnalytics(this.eventId).pipe(take(1)).subscribe(() => {
                this.store.select(getChatsAnalytics).subscribe((chatsAnalytics) => {
                    this.totalChats = (chatsAnalytics && chatsAnalytics.totalChats) ? chatsAnalytics.totalChats : 0;
                    this.totalChatsUsers = (chatsAnalytics && chatsAnalytics.totalChatsUsers) ? chatsAnalytics.totalChatsUsers : 0;
                    this.totalMessagesOnChats = (chatsAnalytics && chatsAnalytics.totalMessagesOnChats) ? chatsAnalytics.totalMessagesOnChats : 0;
                    this.totalDiscussionGroups = (chatsAnalytics && chatsAnalytics.totalDiscussionGroups) ? chatsAnalytics.totalDiscussionGroups : 0;
                    this.totalDiscussionGroupsUsers = (chatsAnalytics && chatsAnalytics.totalDiscussionGroupsUsers) ? chatsAnalytics.totalDiscussionGroupsUsers : 0;
                    this.totalMessagesOnDiscussionGroups = (chatsAnalytics && chatsAnalytics.totalMessagesOnDiscussionGroups) ? chatsAnalytics.totalMessagesOnDiscussionGroups : 0;

                    this.loader = false;
                })
            });
        });
    }

    /**
     * Export analytics of chats
     */
    exportAll() {
        this.loader = true;
        this.dbAnalytics.exportChatsAnalytics(this.eventId, this.userLanguage).subscribe(() => {
            this.loader = false;
        }, (error) => {
            console.log("Error: ", error);
            this.loader = false;
        })
    }
}
